import { render, staticRenderFns } from "./practiceDailySix.vue?vue&type=template&id=42a88693&scoped=true"
import script from "./practiceDailySix.vue?vue&type=script&lang=js"
export * from "./practiceDailySix.vue?vue&type=script&lang=js"
import style0 from "./practiceDailySix.vue?vue&type=style&index=0&id=42a88693&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a88693",
  null
  
)

export default component.exports